
import React,{useEffect, useState, useRef} from 'react'
import "../css/Home.css";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import TopNavbar from '../components/TopNavbar';
import MomentBar from '../components/MomentBar';
import PostDetail from '../components/PostDetail';
import { formatCount } from '../utils/format';
import AdVideo from '../AdMedia/AdVideo.mp4';

export default function Home() {
  var picLink = "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [comment, setComment] = useState("");
  const [show, setShow] = useState(false);
  const [item, setItem] = useState([]);
  const [mediaIndices, setMediaIndices] = useState({});
  const limitRef = useRef(3)
  const skipRef = useRef(0)
  const loadingRef = useRef(false)
  const hasMoreRef = useRef(true)
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  // Toast Functions
  const notifyA = (msg) => toast.error(msg)
  const notifyB = (msg) => toast.success(msg)

  useEffect(() =>{ 
    const token = localStorage.getItem("jwt");
    if(!token){
      navigate("./signup")
      return;
    }
    fetchPosts()

    // listen for scroll on window and on the main `.home` container (some layouts use inner scrolling)
    window.addEventListener("scroll", handleScroll);
    const container = document.querySelector('.home');
    if (container && container !== window) container.addEventListener('scroll', handleScroll);
    return ()=>{
      window.removeEventListener("scroll",handleScroll)
      if (container && container !== window) container.removeEventListener('scroll', handleScroll)
    }
    
  }, [navigate]);

  const [aboutFilter, setAboutFilter] = useState('');
  const [interestFilter, setInterestFilter] = useState(() => {
    try {
      const u = JSON.parse(localStorage.getItem('user') || 'null');
      return (u && u.interests) ? u.interests : '';
    } catch (e) { return ''; }
  });
  const [showFilterRequiredMessage, setShowFilterRequiredMessage] = useState(false);
  const debounceRef = useRef(null);
  const requestIdRef = useRef(0);

  const applyFilters = () => {
    // immediate apply (user clicked)
    setData([]);
    skipRef.current = 0;
    hasMoreRef.current = true;
    setHasMore(true);
    setShowFilterRequiredMessage(false);
    fetchPosts(true);
  }

  const clearFilters = () => {
    setAboutFilter('');
    setInterestFilter('');
    setData([]);
    skipRef.current = 0;
    hasMoreRef.current = true;
    setHasMore(true);
    // when both filters empty, show instruction instead of fetching
    setShowFilterRequiredMessage(true);
    // immediate effect
    return;
  }

  const fetchPosts = (reset = false) =>{
    // allow reset fetch even if a previous fetch is running
    if (!reset && (loadingRef.current || !hasMoreRef.current)) return;
    const myReqId = ++requestIdRef.current;
    loadingRef.current = true;
    // Fetching all posts
    setLoading(true);
    // require at least one filter
    if (!aboutFilter && !interestFilter) {
      // clear results and show message
      setData([]);
      hasMoreRef.current = false;
      setHasMore(false);
      setLoading(false);
      loadingRef.current = false;
      setShowFilterRequiredMessage(true);
      return;
    }
    setShowFilterRequiredMessage(false);
    let url = `/allposts?limit=${limitRef.current}&skip=${skipRef.current}`;
    if (aboutFilter) url += `&aboutPostQuery=${encodeURIComponent(aboutFilter)}`;
    if (interestFilter) url += `&interestQuery=${encodeURIComponent(interestFilter)}`;
    fetch(url,{
      headers:{
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
    })
      .then(res => {
        if (res.status === 401) {
          // unauthorized, clear token and redirect
          localStorage.removeItem('jwt');
          localStorage.removeItem('user');
          navigate('/signup');
          return null;
        }
        return res.json();
      })
      .then((result) => {
        if (!result) return;
        // ignore out-of-order responses
        if (myReqId !== requestIdRef.current) {
          loadingRef.current = false; setLoading(false); return;
        }
        console.log(result);
        const count = Array.isArray(result) ? result.length : 0;
        setData((prev)=>{
          const existingIds = new Set(prev.map(p=>p._id));
          const merged = [...prev];
          for(const r of result){
            if(!existingIds.has(r._id)){
              merged.push(r);
              existingIds.add(r._id);
            }
          }
          return merged;
        });
        // advance skip by number of items returned so subsequent fetches request the next page
        skipRef.current = skipRef.current + count;
        // if fewer than requested were returned, no more pages
        if (count < limitRef.current){
          setHasMore(false);
          hasMoreRef.current = false;
        }
      })
      .catch((err) => console.log(err))
      .finally(()=> { loadingRef.current = false; setLoading(false); });
  }

  const handleScroll = () =>{
    if (!hasMoreRef.current) return;
    const scrolledToBottom = (document.documentElement.clientHeight + window.pageYOffset >= document.documentElement.scrollHeight - 200);
    const container = document.querySelector('.home');
    const containerAtBottom = container ? (container.scrollTop + container.clientHeight >= container.scrollHeight - 200) : false;
    if (scrolledToBottom || containerAtBottom) {
      fetchPosts();
    }
  }

  // debounce filter inputs
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    // if both empty, update immediately (show message)
    if (!aboutFilter && !interestFilter) {
      setData([]); skipRef.current = 0; hasMoreRef.current = true; setHasMore(true); setShowFilterRequiredMessage(true);
      return;
    }
    debounceRef.current = setTimeout(() => {
      setData([]); skipRef.current = 0; hasMoreRef.current = true; setHasMore(true); setShowFilterRequiredMessage(false);
      fetchPosts(true);
    }, 250);
    return () => { if (debounceRef.current) clearTimeout(debounceRef.current); }
  }, [aboutFilter, interestFilter]);

  // show and hide comments
  const toggleComment = (posts)=>{
    if(show){
      setShow(false);
    }else{
      setShow(true);
      setItem(posts);
      
    }
  }

  const changeMediaIndex = (postId, direction, mediaLength) => {
    setMediaIndices(prev => {
      const currentIdx = prev[postId] || 0;
      const newIdx = direction === 'next' 
        ? (currentIdx + 1) % mediaLength 
        : (currentIdx - 1 + mediaLength) % mediaLength;
      return { ...prev, [postId]: newIdx };
    });
  }

  const [mediaPlaying, setMediaPlaying] = useState({});
  const playMedia = (postId) => setMediaPlaying(prev => ({...prev, [postId]: true}));
  const [expandedCaptions, setExpandedCaptions] = useState({});
  const toggleCaption = (id) => setExpandedCaptions(prev => ({...prev, [id]: !prev[id]}));


  const likePost = (id) =>{
    fetch("/like",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        postId:id
      })
    }).then(res=>res.json())
    .then((result)=>{
      const newData = data.map((posts)=>{
        if(posts._id === result._id){
          return result
        }else{
          return posts
        }
      })
      setData(newData)
      console.log(result)
    })
  }
  const unlikePost = (id) =>{
    fetch("/unlike",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        postId:id
      })
    }).then(res=>res.json())
    .then((result)=>{
      const newData = data.map((posts)=>{
        if(posts._id === result._id){
          return result
        }else{
          return posts
        }
      })
      setData(newData);
      console.log(result);
    })
  };

  // function to make comment
  const makeComment = (text,id) =>{
    if (!text || !text.trim()) { notifyA('Comment cannot be empty'); return; }
    if (text.length > 128) { notifyA('Comment cannot exceed 128 characters'); return; }
    fetch("/comment",{
      method:"put",
      headers:{
        "Content-Type":"application/json",
        Authorization: "Bearer " + localStorage.getItem("jwt")
      },
      body:JSON.stringify({
        text:text,
        postId:id,
      }),
    })
      .then(res=>res.json())
      .then((result)=>{
        const newData = data.map((posts)=>{
          if(posts._id === result._id){
            return result
          }else{
            return posts
          }
        })
        setData(newData);
        setComment("");
        notifyB("Comment Posted");
        console.log(result);
      });
  };

  // Open app's account profile by username
  // (App account feature removed)

  return (
    <div className='home'>
      <TopNavbar
        showFilters={true}
        forceHide={show}
        aboutFilter={aboutFilter}
        setAboutFilter={setAboutFilter}
        interestFilter={interestFilter}
        setInterestFilter={setInterestFilter}
        applyFilters={applyFilters}
        clearFilters={clearFilters}
      />
      <MomentBar />
          {/* card */}
          {showFilterRequiredMessage ? (
            <div style={{padding:20,textAlign:'center',color:'#666'}}>Fill any one of the filters to see posts</div>
          ) : data.map((posts, idx) => {
            return (
              <React.Fragment key={posts._id}>
                <div className="card">
                {/* card-header */}
                <div className="card-header">
                  <div className="card-pic">
                    <img src={posts.postedBy.Photo? posts.postedBy.Photo : picLink} alt="" />
                  </div>
                  <h5>
                    <Link to={`/profile/${posts.postedBy._id}`}>
                      {posts.postedBy.name}
                    </Link>
                  </h5>
                  <span onClick={() => navigate('/profile/home-post-options')} className="material-symbols-outlined">more_vert</span>
                </div>
                {/* card image */}
                <div className="card-image" style={{position:'relative'}}>
                  {posts.media && posts.media.length > 0 ? (
                    <>
                      {(() => {
                        const idx = mediaIndices[posts._id] || 0;
                        const m = posts.media[idx];
                        if (m.type === 'image') return (<img src={m.url} alt="" />);
                        if (m.type === 'video') {
                          // prefer thumbnail for feed preview; clicking thumbnail plays video with controls
                          const isPlaying = mediaPlaying[posts._id];
                          if (m.thumbnail && !isPlaying) {
                            return (
                              <div style={{position:'relative', cursor: 'pointer'}} onClick={() => playMedia(posts._id)}>
                                <img src={m.thumbnail} alt="" style={{width:'100%'}} />
                                <div style={{position:'absolute',right:8,bottom:8,background:'rgba(0,0,0,0.5)',borderRadius:12,width:28,height:28,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:18}}>▶</div>
                              </div>
                            );
                          }
                          return (<video src={m.url} controls muted playsInline preload="metadata" style={{width:'100%'}} />);
                        }
                        return null;
                      })()}
                      {posts.media.length > 1 && (
                        <>
                          <button onClick={() => changeMediaIndex(posts._id, 'prev', posts.media.length)} style={{position:'absolute',top:'50%',left:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer',padding:'5px 10px'}}>‹</button>
                          <button onClick={() => changeMediaIndex(posts._id, 'next', posts.media.length)} style={{position:'absolute',top:'50%',right:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer',padding:'5px 10px'}}>›</button>
                        </>
                      )}
                    </>
                  ) : (
                    <img src={posts.photo} alt="" />
                  )}
                </div>

                {/* card-content */}
                <div className="card-content">
                  {
                    posts.likes.includes(JSON.parse(localStorage.getItem("user"))._id)
                    ?
                    (<span className="material-symbols-outlined material-symbols-outlined-red" onClick={() => { unlikePost(posts._id) }}>favorite</span>)
                    :(<span className="material-symbols-outlined" onClick={() => { likePost(posts._id) }}>favorite</span>)
                  }
                  
                  

                  <p>{formatCount(posts.likes.length)} Likes</p>
                  <p>
                    {(() => {
                      const caption = posts.body || '';
                      const limit = 100;
                      const isExpanded = !!expandedCaptions[posts._id];
                      if (caption.length <= limit) return caption;
                      return (
                        <>
                          {isExpanded ? caption : `${caption.slice(0, limit)}...`}
                          <span onClick={() => toggleCaption(posts._id)} style={{color:'#0084ff',cursor:'pointer',marginLeft:6}}>{isExpanded ? 'Read less' : 'Read more'}</span>
                        </>
                      )
                    })()}
                  </p>
                  <p style={{fontWeight:"bold", cursor:"pointer"}} onClick={()=>{
                    toggleComment(posts);
                  }} >View all comments</p>
                </div>

                {/* add-comment */}
                <div style={{marginBottom:"60px"}} className="add-comment">
                <span className="material-symbols-outlined">sentiment_satisfied</span>
                <input type="text" placeholder='Add a comment' value={comment} onChange={(e)=>{setComment(e.target.value.slice(0,128))}} maxLength={128} />
                <button 
                  className='comment' 
                  onClick={()=>{
                    makeComment(comment,posts._id);
                  }}
                >
                  Post
                </button>
                </div>
                </div>

                {/* Advertisement after every 3 posts */}
                {((idx + 1) % 3 === 0) && (
                  <div className="card ad-card" style={{display:'none', padding:12,marginTop:12,marginBottom:12}}>
                    <div style={{fontWeight:'bold',marginBottom:8}}>Sponsored</div>
                    <div style={{position:'relative'}}>
                      <video src={AdVideo} controls style={{width:'100%',borderRadius:6}} preload="metadata" />
                    </div>
                    <div style={{display:'flex',gap:6,marginTop:8}}>
                      <a href="https://www.instagram.com/bharat__music/?hl=en" target="_blank" rel="noopener noreferrer" style={{flex:1,textAlign:'center',padding:8,background:'#E1306C',color:'#fff',borderRadius:6,textDecoration:'none'}}>Instagram</a>
                      <a href="https://www.youtube.com/@bharatchandak11" target="_blank" rel="noopener noreferrer" style={{flex:1,textAlign:'center',padding:8,background:'#FF0000',color:'#fff',borderRadius:6,textDecoration:'none'}}>YouTube</a>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
      })}

      {loading && (
        <div style={{display:'flex',justifyContent:'center',padding:16}} className="infinite-spinner">
          <div className="spinner" aria-hidden="true"></div>
        </div>
      )}

      {/* show Comment */}
      {show && (
        <PostDetail item={item} toggleDetails={toggleComment} hideDelete={true} />
      )}
    </div>
  );
}

